<template>
    <div class="project-structure-tree">
        <div 
            class="project-structure-tree-settings"
            :style="`background-color: ${background_color};`"
            v-if="depth === 1"
            >
            <TTooltip value="wrapper_settings" right>
                <ButtonOutlined
                    :class="`pointer_all`"
                    height="16" 
                    width="16"
                    icon="horizontal-dots"            
                    @buttonClicked="show_wrapper_settings = true"
                />
            </TTooltip>
            <v-spacer></v-spacer>
            <TIcon 
                v-if="$store.state.ProjectStructure.filter[tree_type].active"
                name="filter-inverted"
            />
            <TText :value="tree_title" />
            <div 
                v-if="show_wrapper_settings"
                class="project-structure-tree-settings-popup"
                v-click-outside="toggleWrapperSettings"
                >
                <div class="d-flex"
                  v-for="(setting, index) in Object.keys($store.state.ProjectStructure.tree_settings_wrapper[tree_name])"
                  :key="index">
                  <RadialCheckbox foreground_color="white"
                    :is_checked="$store.state.ProjectStructure.tree_settings_wrapper[tree_name][setting]"
                    @setActive="updateSetting({ type: 'wrapper', tree: tree_name, setting: setting, value: !$store.state.ProjectStructure.tree_settings_wrapper[tree_name][setting] })" />
                  <TIcon :name="$store.state.Ultra.icon_by_type[setting]" />
                  <TText :value="setting" />
                </div>
            </div>
        </div>
        <TIntersectionWrapper min_height="28px" 
        :style="is_element ? `position: relative; z-index: 0;
        background-color: ${background_color};` 
        : `position: sticky; top: ${(depth - 1) * 28}px; z-index: ${50 - depth};
         background-color: ${background_color};`"
            :class="'project-structure-tree-wrapper'" :depth="depth + 1">

            <template #default>
                <div class="project-structure-tree-header" @click="object.type !== 'object_wrapper' ? $emit('clickHeader', object) : ''" :style="`border-left: 2px ${is_active_element ? 'solid': 'dashed'} ${contains_active_element ? 'red' : 'transparent'};`">
                    <div class="project-structure-tree-header-buttons">
                        <TIcon :color="getForegroundColor(depth)" v-if="!is_element && (tree_name !== 'element_taktareas' || object.type !== 'taktareas')" :name="open ? 'chevron-down' : 'chevron-right'"
                            @click.native.prevent.stop="open = !open" />


                        <div class="basic-flex-row" v-if="$store.state.ProjectStructure.ui_mode === 'link'">
                            <div v-if="tree_type === 'spatial'" class="basic-flex-col" style="width:30px;">
                                <!-- <TText :color="getForegroundColor(depth)" value="TA {link}" :value_props="{link: object_taktarea_linked_icon}" size="8" />
                                <TText :color="getForegroundColor(depth)" value="ST {link}" :value_props="{link: object_step_linked_icon}" size="8" /> -->
                                <div class="basic-flex-row" style="grid-gap: 2px;justify-content: flex-start;">
                                    <TText :color="getForegroundColor(depth)" value="TA" size="8" />
                                    <TIcon :color="getForegroundColor(depth)" size="12" :name="object_taktarea_linked_icon === 0 ? 'link-defect' : object_taktarea_linked_icon === 1 ? 'link' : object_taktarea_linked_icon === 2 ? 'link-check' : 'link-defect'" />
                                </div>
                                <div class="basic-flex-row" style="grid-gap: 2px;justify-content: flex-start;">
                                    <TText :color="getForegroundColor(depth)" value="ST" size="8" />
                                    <TIcon :color="getForegroundColor(depth)" size="12" :name="object_step_linked_icon === 0 ? 'link-defect' : object_step_linked_icon === 1 ? 'link' : object_step_linked_icon === 2 ? 'link-check' : 'link-defect'" />
                                </div>
                            </div>
                            <div v-if="tree_type === 'process'" class="basic-flex-col" style="width:30px;">
                                <!-- <div class="basic-flex-row" style="grid-gap: 2px;justify-content: flex-start;">
                                    <TText :color="getForegroundColor(depth)" value="EL" size="8" />
                                    <TIcon :color="getForegroundColor(depth)" size="12" :name="object_element_linked_icon === 0 ? 'link-defect' : object_element_linked_icon === 1 ? 'link' : object_element_linked_icon === 2 ? 'link-check' : 'link-defect'" />
                                </div> -->

                                <div v-if="['projects', 'trains', 'taktareas'].includes(object.type)" class="basic-flex-row" style="grid-gap: 2px;justify-content: flex-start;">
                                    <TText :color="getForegroundColor(depth)" value="TA" size="8" />
                                    <TIcon :color="getForegroundColor(depth)" size="12" :name="object_ta_element_linked_icon === 0 ? 'link-defect' : object_ta_element_linked_icon === 1 ? 'link' : object_ta_element_linked_icon === 2 ? 'link-check' : 'link-defect'" />
                                </div>
                                <div class="basic-flex-row" style="grid-gap: 2px;justify-content: flex-start;">
                                    <TText :color="getForegroundColor(depth)" value="ST" size="8" />
                                    <TIcon :color="getForegroundColor(depth)" size="12" :name="object_element_linked_icon === 0 ? 'link-defect' : object_element_linked_icon === 1 ? 'link' : object_element_linked_icon === 2 ? 'link-check' : 'link-defect'" />
                                </div>




                                <!-- <TText :color="getForegroundColor(depth)" value="EL {link}" :value_props="{link: object_element_linked_icon}" size="8" /> -->
                            </div>
                        </div>
                        

                        <div v-if="object.type === 'twaggons'">
                            <TIconWaggon :waggon="object" :workpackages="getUObjects({ type:'tworkpackages', ids: object.tworkpackages})" class="mr-2" />
                        </div>
                        <div v-else-if="object.type === 'tworkpackages'">
                            <TIconWorkPackage :workpackage="object" class="mr-2" />
                        </div>
                        <div v-else>
                            <TIcon v-if="object.type === 'elements'" :color="getForegroundColor(depth)" 
                            :name="getIFCElementIcon(object.name)" />
                            <TIcon v-else-if="object.type === 'object_wrapper'" :color="getForegroundColor(depth)" 
                            :name="getObjectWrapperIcon(object.name)" />
                            <TIcon v-else :color="getForegroundColor(depth)" 
                            :name="getWrapperIcon(object.type)" />
                        </div>
                    </div>
                    <div class="project-structure-tree-header-title">
                        <TText :color="getForegroundColor(depth)" :text="display_text">
                        </TText>
                        <!-- v-if="object.type === 'object_wrapper'" -->
                        <TText :color="getForegroundColor(depth)" 
                            v-if="object.type !== 'elements' && !object.type.includes('steps')"
                            class="ml-2" 
                            :text="`(${contained_ids_by_target[targets[0]].length})`">
                        </TText>
                        <!-- :text="`(${contained_ids_by_target[tree_name === 'taktarea_elements'?'ta_elements':object.content_type].length})`"> -->
                    </div>

                    <div class="project-structure-tree-header-buttons" @click.prevent.stop>

                        <template v-if="tree_name==='process_tree'">
                            <TTooltip v-if="contained_ids_by_target.tworksteps.length === 0" value="Please add WORK.steps to your WORK.packages.">
                                <TIcon name="exclamation-triangle" />
                            </TTooltip>
                        </template>
                        <template v-if="tree_name==='spatial_tree'">
                            <TTooltip v-if="contained_ids_by_target.elements.length === 0" value="Please import an IFC or add elements.">
                                <TIcon name="exclamation-triangle" />
                            </TTooltip>
                        </template>
                        
                        <TTooltip value="Create spatial wrapper and elements" v-if="tree_name === 'spatial_tree' && !['object_wrapper', 'elements'].includes(object.type) && $store.state.ProjectStructure.ui_mode === 'edit'">
                            <TIcon :color="getForegroundColor(depth)" name="sign-plus" @click.native.prevent.stop="setValue({ key: 'project_structure_create_dialog', value: { show: true, object: object }})" 
                            />
                        </TTooltip>

                        <template>
                            <!-- selection -->
                            <TTooltip :value="is_selected_result === 'complete' ? 'Remove from selection' : 'Add to Selection' ">
                                <TIcon :color="getForegroundColor(depth)" 
                                :name="is_selected_result === 'complete' ? 'checkbox-radial-filled' : is_selected_result === 'part'?'radial-checkbox-dashed':'checkbox-radial-empty'" 
                                @click.native.prevent.stop="setCollection(tree_type === 'spatial'?'selected_elements':'selected_steps', is_selected_result)" 
                                />
                            </TTooltip>
                            <!-- visible -->
                            <TTooltip v-if="tree_type === 'spatial'" value="Set 3D">
                                <TIcon :color="getForegroundColor(depth)" 
                                    name="visiblity-single"
                                    @click.native.prevent.stop="showSingleElementOrWrapper(object)" 
                                />
                            </TTooltip>
                            <!-- visible -->
                            <TTooltip v-if="tree_type === 'spatial'" :value="is_visible_result === 'complete' ? 'Remove from 3D' : 'Add to 3D' ">
                                <TIcon :color="getForegroundColor(depth)" 
                                    :name="is_visible_result === 'complete' ? 'visibility-on' : is_visible_result === 'part'?'visiblity-half':'visibility-off'" 
                                    @click.native.prevent.stop="setCollection('visible_elements', is_visible_result)" 
                                />
                            </TTooltip>
                        </template>

                    </div>
                </div>
            </template>
        </TIntersectionWrapper>
        <!-- whats that? -->
        <!-- <div class="project-structure-tree-body" v-if="parents">
            <template v-if="open">
                <ProjectStructureTree v-for="parent in object.children" :key="parent.type + parent.id" :object="parent"
                    :depth="depth + 1" @clickHeader="$emit('clickHeader', $event)">
                </ProjectStructureTree>
            </template>
        </div> -->
        <div class="project-structure-tree-body">
            <!-- <template v-if="tree_name==='process_tree'">
                <TText v-if="contained_ids_by_target.tworksteps.length === 0" class="mt-1" value="Please add WORK.steps to your WORK.packages." />
            </template>
            <template v-if="tree_name==='spatial_tree'">
                <TText v-if="contained_ids_by_target.elements.length === 0" class="mt-1" value="Please import an IFC or add elements." />
            </template> -->

            <template 
                v-for="child in getTreeChildObjects({parent: object, tree_type: tree_type, tree_name: tree_name})"
                >
                <!-- v-if="(open && !filtered_ids) || (open && filtered_ids && isSet1inSet2({tree_type: tree_type, object: child, ids: filtered_ids, targets: ['elements']}).result !== 'none')" -->
                <!-- v-if="open && isSet1inSet2({tree_type: tree_type, object: child, collection_object: collection_object}).result !== 'none'" -->
                
                <ProjectStructureTree
                    v-if="open && isSet1inSet2({
                        set1: {type: 'object', value: child, tree_type: tree_type},
                        set2: {type: 'ids_by_target', value: collection_object},
                        targets: targets,
                        set1_empty_case: $store.state.ProjectStructure.tree_settings_wrapper[tree_name]['show_empty_wrapper'] ? 'complete' : false
                        // tree_type: tree_type, 
                        // object: child, 
                        // collection_object: collection_object
                        }).result !== 'none'"
                    :key="`${child.type} ${child.id}`" 
                    :tree_type="tree_type"
                    :tree_name="tree_name"
                    :collection_object="collection_object"
                    :targets="targets"
                    :object="child"
                    :depth="depth + 1"
                    :active_spatial_element="active_spatial_element"
                    :active_process_element="active_process_element"
                    @clickHeader="$emit('clickHeader', $event)"
                    >
                </ProjectStructureTree>
            </template>
        </div>
    </div>
</template>
<script>
import ProjectStructureTree from '@/components/ProjectStructureRework/ProjectStructureTree.component.vue';
import TIntersectionWrapper from '@/components/Taktify/TIntersectionWrapper.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TIconWorkPackage from '@/components/Taktify/TIconWorkPackage.component.vue';
import TIconWaggon from '@/components/Taktify/TIconWaggon.component.vue';
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue'
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';


import { mapGetters, mapActions } from 'vuex';

// import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';

export default {
    props: ['tree_type', 'tree_name', 'object', 'depth', 'collection_object', 'targets', 'active_spatial_element', 'tree_title', 'active_process_element'],
    name: 'ProjectStructureTree',
    components: {
        ProjectStructureTree,
        TIntersectionWrapper,
        TIcon,
        TIconWorkPackage,
        TIconWaggon,
        ButtonOutlined,
        TTooltip,
        RadialCheckbox,
        // TWorkPackage,
    },
    data: () => ({
        open: false, //instead of object.open 
        show_wrapper_settings: false,
    }),
    created() {
        if (this.object.type === 'projects') {
            this.open = true;
        }
    },
    computed: {
        ...mapGetters('ProjectStructure', [
            'isSet1inSet2',
            'isSet1LinkedToSet2',
            'getAllChildObjectIds',
            'getTreeChildObjects',
            'getBackgroundColor',
            'getForegroundColor',
            'getObjectUrl',
        ]),
        ...mapGetters('Ultra', [
            'getUObject',
            'getUObjects',
            'getIFCElementIcon',
            'getObjectWrapperIcon',
            'getWrapperIcon',
        ]),
        project(){
            return this.getUObject({ type: 'projects', id: this.$route.params.project_id });
        },
        object_taktarea_linked_icon(){

            if (this.tree_type === 'process') {
                return -1;
            }
            const res = this.isSet1LinkedToSet2({
                set1: {type: 'object', value: this.object, tree_type: 'spatial'},
                set2: {type: 'object', value: this.project, tree_type: 'process'},
                targets: ['ta_elements'],
            });

            // none
            if (res.result === 'none') {
                return 0;
            }
            // part
            if (res.result === 'part') {
                return 1;
            }
            // min 1
            if (res.result === 'complete') {
                return 2;
            }
            return 6;
        },
        object_step_linked_icon(){

            if (this.tree_type === 'process') {
                return -1;
            }
            const res = this.isSet1LinkedToSet2({
                set1: {type: 'object', value: this.object, tree_type: 'spatial'},
                set2: {type: 'object', value: this.project, tree_type: 'process'},
                targets: ['elements'],
            });

            // none
            if (res.result === 'none') {
                return 0;
            }
            // part
            // if (res.result === 'part' && res.all_min_1 === false) {
            if (res.result === 'part') {
                return 1;
            }
            // min 1
            // if ((res.result === 'part' && res.all_min_1 === true) || res.result === 'complete') {
            if (res.result === 'complete') {
                return 2;
            }
            return 6;
        },
        object_element_linked_icon(){

            if (this.tree_type === 'spatial') {
                return -1;
            }
            const res = this.isSet1LinkedToSet2({
                set1: {type: 'object', value: this.object, tree_type: 'process'},
                set2: {type: 'object', value: this.project, tree_type: 'spatial'},
                targets: ['tworksteps'],
            });

            // none
            if (res.result === 'none') {
                return 0;
            }
            // part
            if (res.result === 'part') {
                return 1;
            }
            // min 1
            if (res.result === 'complete') {
                return 2;
            }
            return 6;
        },
        object_ta_element_linked_icon(){

            if (this.tree_type === 'spatial') {
                return -1;
            }
            const res = this.isSet1LinkedToSet2({
                set1: {type: 'object', value: this.object, tree_type: 'process'},
                set2: {type: 'object', value: this.project, tree_type: 'spatial'},
                targets: ['taktareas'],
            });

            // none
            if (res.result === 'none') {
                return 0;
            }
            // part
            if (res.result === 'part') {
                return 1;
            }
            // min 1
            if (res.result === 'complete') {
                return 2;
            }
            return 6;
        },
        is_element() {
            return this.object.type === 'elements' || this.object.type.includes('steps');
        },
        is_active_element(){
            if(this.contains_active_element) {
                if (
                    (this.active_spatial_element && this.active_spatial_element.type === this.object.type) ||
                    (this.active_process_element && this.active_process_element.type === this.object.type)
                    ) {
                    return true;
                }
            }
            return false;
        },  
        contains_active_element(){
            if (this.active_spatial_element) {
                if (this.object.type === 'elements' && this.active_spatial_element.type === 'elements') {
                    if (this.object.id === this.active_spatial_element.id) {
                        return true;
                    }
                }
                if (this.active_spatial_element.type === 'elements') {
                    const contained_elements = this.getAllChildObjectIds({parent: this.object, tree_type: this.tree_type, targets: ['elements']});
                    if (contained_elements.elements.includes(this.active_spatial_element.id)) {
                        return true;
                    }
                } else {
                    const path = this.getObjectUrl(this.active_spatial_element).path;
                    for (let index = 0; index < path.length; index++) {
                        const path_element = path[index];
                        if (path_element.type === this.object.type && path_element.id === this.object.id) {
                            return true;
                        }
                    }
                }
            }
            if (this.active_process_element) {
                if (this.object.type === 'tworksteps' && this.active_process_element.type === 'tworksteps') {
                    if (this.object.id === this.active_process_element.id) {
                        return true;
                    }
                }
                if (this.active_process_element.type === 'tworksteps') {
                    const contained_elements = this.getAllChildObjectIds({parent: this.object, tree_type: this.tree_type, targets: ['tworksteps']});
                    if (contained_elements.tworksteps.includes(this.active_process_element.id)) {
                        return true;
                    }
                } else {
                    const path = this.getObjectUrl(this.active_process_element).path;
                    for (let index = 0; index < path.length; index++) {
                        const path_element = path[index];
                        if (path_element.type === this.object.type && path_element.id === this.object.id) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },
        contained_ids_by_target() {
            // contained ids
            // smallest object ids of wrapper -> steps || elements
            let ids_by_target = {};
            let result = this.isSet1inSet2({
                set1: {type: 'object', value: this.object, tree_type: this.tree_type},
                set2: {type: 'ids_by_target', value: this.collection_object},
                targets: this.targets,
                // tree_type: this.tree_type, 
                // object: this.object, 
                // collection_object: this.collection_object
            });
            let result_by_target = result.result_by_target;
            Object.keys(result_by_target).forEach(target_key => {
                ids_by_target[target_key] = result_by_target[target_key].contained_ids;
            });

            if (result.result === 'none') {
                return { [this.targets[0]]: []}
            }

            return ids_by_target;
        },
        is_visible_result() {

            return this.isSet1inSet2({
                set1: {type: 'ids_by_target', value: this.contained_ids_by_target},
                set2: {type: 'collection_name', value: 'visible_elements'},
                targets: this.targets,
                // tree_type: this.tree_type, 
                // ids_by_target: this.contained_ids_by_target, 
                // collection_name: 'visible_elements'
            }).result;
        },
        is_selected_result() {
            let collection_name;
            if (this.tree_type === 'spatial') {
                collection_name = 'selected_elements';
            } else {
                collection_name = 'selected_steps';
            }
            let ret = this.isSet1inSet2({
                set1: {type: this.tree_name !== 'element_taktareas'?'ids_by_target':'object', value: this.tree_name !== 'element_taktareas'?this.contained_ids_by_target:this.object, tree_type: this.tree_type},
                set2: {type: 'collection_name', value: collection_name},
                targets: this.tree_name !== 'element_taktareas'?this.targets:['tworksteps'],
                // tree_type: this.tree_type, 
                // object: this.object, 
                // ids_by_target: this.tree_name !== 'element_taktareas'?this.contained_ids_by_target:false, 
                //collection_name: collection_name
            }).result;

            return ret;
        },
        background_color(){
            return this.getBackgroundColor(this.depth);
        },
        display_text(){
            // currently only works if its layered like this... not sure why?
            if (this.object){
                if (this.object.type){
                    if (this.object.type.includes('steps')){
                        return this.object.text;
                    } else if (this.object.type === 'twaggons') {
                        if (this.object.token) {
                            return this.object.token;
                        }
                        return `Wagon #${this.object.position}`;
                    } else {
                        return this.object.name;
                    }
                }
            }
            return '';
        }
    },
    methods: {
        ...mapActions('ProjectStructure', [
            'setCollectionObjects',
            'updateSetting',
        ]),
        ...mapActions('View', [
            'setValue',
        ]),
        showSingleElementOrWrapper(object){
            if (object.type === 'elements') {
                this.setCollectionObjects({ action: 'set', ids_by_target: {elements: [object.id]}, collection_name: 'visible_elements' });
            } else {
                if (this.tree_name === 'spatial_collection') {
                    const result = this.isSet1inSet2({
                        set1: { type: 'object', value: object, tree_type: this.tree_type },
                        set2: { type: 'collection_name', value: 'selected_elements' },
                        targets: ['elements'],
                    });
                    this.setCollectionObjects({ action: 'set', ids_by_target: { elements: result.result_by_target.elements.contained_ids }, collection_name: 'visible_elements' });
                } else if (this.tree_name === 'spatial_tree'){
                    const result = this.getAllChildObjectIds({parent: object, tree_type: this.tree_type, targets: ['elements']});
                    this.setCollectionObjects({ action: 'set', ids_by_target: result, collection_name: 'visible_elements' });
                } else if (this.tree_name === 'taktarea_elements') {
                    const result = this.isSet1inSet2({
                        set1: { type: 'object', value: object, tree_type: this.tree_type },
                        set2: { type: 'ids_by_target', value: this.collection_object },
                        targets: ['ta_elements'],
                    });
                    this.setCollectionObjects({ action: 'set', ids_by_target: { elements: result.result_by_target.ta_elements.contained_ids }, collection_name: 'visible_elements' });
                } else if (this.tree_name === 'step_elements') {
                    const result = this.isSet1inSet2({
                        set1: { type: 'object', value: object, tree_type: this.tree_type },
                        set2: { type: 'ids_by_target', value: this.collection_object },
                        targets: ['elements'],
                    });
                    this.setCollectionObjects({ action: 'set', ids_by_target: { elements: result.result_by_target.elements.contained_ids }, collection_name: 'visible_elements' });
                }
            }
        },
        setCollection(collection_name, result) {
            let ids_by_target = {};
            if (this.tree_name === 'element_taktareas') { //hande taktareas
                ids_by_target = this.getAllChildObjectIds({parent: this.object, tree_type: this.tree_type, targets: ['tworksteps']});
            } 
            else if (Object.keys(this.contained_ids_by_target).includes('ta_elements')) {
                ids_by_target.elements = this.contained_ids_by_target.ta_elements;
            } 
            else {
                ids_by_target = this.contained_ids_by_target;
            }
            this.setCollectionObjects({
                action: result === 'complete' ? 'remove' : 'add',
                ids_by_target: ids_by_target,
                collection_name: collection_name, // visible, selected
            })
        },
        toggleWrapperSettings() {
            this.show_wrapper_settings = false;
        }
    }

}
</script>
<style>
.project-structure-tree {
    width: 100%;
    min-height: 28px;
    display: flex;
    flex-direction: column;
    position: relative;
    height: fit-content;
}
.project-structure-tree-settings {
    display: flex;
    align-items: center;
    padding: 5px;
}
.project-structure-tree-settings-popup {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 36px;
    /* right: 0px; */
    background-color: #212121;
    z-index: 1000;
    border: 1px solid white;
    border-radius: 6px;
}
.project-structure-tree-header {
    display: flex;
    cursor: pointer;
    width: 100%;
}

.project-structure-tree-wrapper {
    border-radius: 0 0 0 6px;
    display: flex;
    align-items: center;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.project-structure-tree-wrapper:hover {
    right: 0px;
    position: absolute;
}

.project-structure-tree-wrapper:active {
    /* background-color: var(--v-hp-color-drk-b03-base); */
    /* border: 1px solid white; */
}

.project-structure-tree-wrapper:focus {
    /* background-color: var(--v-hp-color-drk-b03-base); */
    /* border: 1px solid blue; */
}

.project-structure-tree-wrapper:target {
    /* background-color: var(--v-hp-color-drk-b03-base); */
    /* background-color: yellow;
    border: 1px solid yellow; */
}


.project-structure-tree-header-title {
    display: flex;
    cursor: pointer;
    position: relative;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 1rem;
    text-align: center;
}

.project-structure-tree-header-buttons {
    position: relative;
    display: flex;
    flex-shrink: none;
}

.project-structure-tree-body {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
}
</style>
  